import { isStatusCodeError } from './isStatusCodeError.ts';

export const isNotFoundError = (error: Parameters<typeof isStatusCodeError>[0]): boolean =>
	isStatusCodeError(error, '404');
